var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', [!_vm.micepecRecords.length ? _c('v-sheet', {
    staticClass: "page-text grey-6--text text-center"
  }, [_vm._v(" 마이스펙 이력이 없습니다. ")]) : [_c('p', {
    staticClass: "page-text--sm grey-6--text mb-8 mb-lg-12"
  }, [_vm._v(" 마이스펙 이력은 해당 지원자의 역량이 마이스펙을 통해 인증되었다는 것을 증명합니다 ")]), _c('v-divider', {
    staticClass: "primary border-2 mb-12 mb-lg-24"
  }), _c('v-sheet', [_vm._l(_vm.micepecRecords, function (item) {
    return [_c('micepec-record-item', _vm._b({
      key: item._id,
      staticClass: "micepec-record-item"
    }, 'micepec-record-item', {
      item,
      mode: _vm.mode
    }, false))];
  })], 2)]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }